/**
 * Instance Configuration
 * Manages organization instances for multi-instance admin portal
 */

export interface InstanceConfig {
  id: string
  name: string
  apiUrl: string
  status: 'active' | 'inactive' | 'provisioning' | 'failed'
  organizationDomain: string
  adminEmail: string
  createdAt: string
}

/**
 * Load instances from API
 * This will be populated from the provisioning API
 */
export async function loadInstances(apiBaseUrl: string): Promise<InstanceConfig[]> {
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      console.warn('No token found, cannot load instances')
      return []
    }

    const response = await fetch(`${apiBaseUrl}/api/v1/provisioning/instances`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      if (response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem('token')
        console.error('Authentication failed, token removed')
        return []
      }
      throw new Error(`Failed to load instances: ${response.status}`)
    }

    const data = await response.json()
    return data.map((inst: any) => ({
      id: inst.id,
      name: inst.name,
      apiUrl: inst.api_url,
      status: inst.status,
      organizationDomain: inst.organization_domain,
      adminEmail: inst.admin_email,
      createdAt: inst.created_at,
    }))
  } catch (error) {
    console.error('Error loading instances:', error)
    return []
  }
}

/**
 * Default instance (for development)
 */
export const defaultInstances: InstanceConfig[] = [
  {
    id: 'local',
    name: 'Local Development',
    apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000',
    status: 'active',
    organizationDomain: 'local.karyva.com',
    adminEmail: 'root@karyva.com',
    createdAt: new Date().toISOString(),
  },
]

